module.exports = __webpack_public_path__ + "static/media/installateur-service.2741690d.svg";